import React from 'react';
import images from '../../Asset/Img/img';

function FooterDefault() {
  return (
    <>
        
        <div className="footer-content">
        <div className='footer-info'>
          <img src={images.logoWhite} alt="Logo" />
          <p>İletişim bilgileri</p>
          <p><strong>Adres :</strong>High Performance Compounds Kauçuk A.Ş.Hasanağa OSB Mah. 15. Cad. No:7 Nilüfer/BURSA </p>
          <p><strong>Telefon :</strong>
            +90 (224) 323 00 13</p>
          <p><strong>Fax :</strong>
            +90 (224) 323 00 14z </p>
          <p><strong>E-Mail :</strong>
            info@hpcompounds.com </p>
        </div>
        <div className='footer-form'>
          <div className='form-container'>
            <h3>Bize Ulaşın</h3>
            <input type="text" name="" id="" placeholder='İsminiz' />
            <input type="email" name="" id="" placeholder='E-Posta Adresiniz' />
            <textarea name="" id="" placeholder='Mesajınız'></textarea>
            <button><img src={images.sendIcon} alt="send-icon" />Gönder</button>
          </div>
        </div>
      </div>

      <div className='copyright'>
        <p>Telif Hakkı © 2022 OETECH Solutions
        </p>
      </div>

    </>
  )
}

export default FooterDefault